import { getAccountScopeUserSettings } from 'owa-session-store';
import { updateAccountScopeUserSettingsAndService } from 'owa-userconfiguration/lib/utils/updateAccountScopeUserSettingsAndService';
import type { MailboxInfo } from 'owa-client-types';
export type ListViewBitFlagsMasks = any;

/**
 * Gets a boolean to indicate if the n th bit is 1
 * @param bitMask represents the nth bit
 * @return true if nth bit is 1, false if 0
 */
export function getIsBitSet(bitMask: ListViewBitFlagsMasks, mailboxInfo: MailboxInfo): boolean {
    const listViewBitFlags =
        getAccountScopeUserSettings(mailboxInfo)?.ViewStateConfiguration?.ListViewBitFlags || 0;

    return !!(bitMask & listViewBitFlags);
}

/**
 * Set bit flag
 * @param value set to 1 if true, 0 otherwise
 * @param bitMask represents the nth bit
 */
export async function setBitAndUpdateAccountScopeUserSettingsAndService(
    value: boolean,
    bitMask: ListViewBitFlagsMasks,
    mailboxInfo: MailboxInfo
): Promise<void> {
    // Already same value, no need to set again and update user config
    if (getIsBitSet(bitMask, mailboxInfo) === value) {
        return;
    }

    const listViewBitFlags =
        getAccountScopeUserSettings(mailboxInfo)?.ViewStateConfiguration?.ListViewBitFlags || 0;

    const newValue: number = value ? listViewBitFlags | bitMask : listViewBitFlags & ~bitMask;

    await updateAccountScopeUserSettingsAndService(mailboxInfo, {
        ViewStateConfiguration: {
            ListViewBitFlags: newValue,
        },
    });
}
